import {
  P44EnvironmentDefaults,
  P44EnvironmentInterface,
} from '../interfaces/P44EnvironmentInterface';

export interface WindowInterface {
  _p44_env: P44EnvironmentInterface;
}

export function getP44Env(): P44EnvironmentInterface {
  return (
    (window as unknown as WindowInterface)._p44_env || P44EnvironmentDefaults
  );
}
